import React, { useEffect, useState } from 'react';
import './App.css';

function Heart({ style }) {
  return (
    <span className="floating-heart" style={style}>❤️</span>
  );
}

export default function App() {
  const [hearts, setHearts] = useState([]);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const initial = Array.from({ length: 6 }, (_, i) => ({
      id: i,
      left: `${10 + i * 14}%`,
      animationDelay: `${i * 0.4}s`,
      size: `${1 + Math.random() * 1.2}rem`,
    }));
    setHearts(initial);
  }, []);

  const handleClick = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 600);
  };

  return (
    <div className="page">
      <div className="bg-layer" />

      <div className="hearts-row">
        {hearts.map(h => (
          <Heart key={h.id} style={{
            left: h.left,
            animationDelay: h.animationDelay,
            fontSize: h.size,
          }} />
        ))}
      </div>

      <main className="center">
        <p className="eyebrow">love you</p>

        <h1
          className={`name ${clicked ? 'pulse' : ''}`}
          onClick={handleClick}
        >
          Zarnigor
          <span className="heart-inline">❤️</span>
        </h1>

        <div className="divider" />

        <p className="tagline">always & forever</p>
      </main>

      <div className="petals">
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className="petal"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 6}s`,
              animationDuration: `${5 + Math.random() * 5}s`,
              fontSize: `${0.6 + Math.random() * 0.8}rem`,
              opacity: 0.6 + Math.random() * 0.4,
            }}
          >
            🌸
          </span>
        ))}
      </div>
    </div>
  );
}
